import React from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";

const HostNameDialog = ({
  visible,
  onHide,
  hostName,
  setHostName,
  onSubmit,
}) => {
  return (
    <Dialog
      visible={visible}
      style={{ width: "calc(100% - 15px)", maxWidth: "400px" }}
      modal
      onHide={onHide}
      header={() => <></>}
    closeIcon="pi pi-times" 
      footer={
        <div>
          
             <Button
            label="Cancel"
            icon="pi pi-times"
            onClick={onHide}
            className="custom-button cancel"
            size="small"
          />
          <Button
            label="Submit"
            icon="pi pi-check"
            onClick={onSubmit}
            disabled={!hostName.trim()}
            className="custom-button"
            size="small"
          />
       
        </div>
      }
    >
      <div>
        <label style={{ display: "block", marginBottom: "10px",padding: "8.5px 14px"
        ,fontWeight:"600"
        ,fontSize:"16px"
        ,fontStyle:"bold"    
        ,color:"black"
         }}>
          Host Name<span style={{ color: "red" }}>*</span>
        </label>
        <InputText
          value={hostName}
          onChange={(e) => setHostName(e.target.value)}
          placeholder="Enter host name"
          style={{ width: "100%",fontSize:"16px" }}
        />
      </div>
    </Dialog>
  );
};

export default HostNameDialog;
